import { useRef, useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let processOptions = [];
function DepartmentProcessTableRow({ index, processTypes, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [processTypeKey, setProcessTypeKey] = useState(0);
	const [processSelected, setProcessSelected] = useState({ name: "processTypeKey", label: "", value: 0 });
	const [isSubmit, setIsSubmit] = useState(false);
	const [processLoaded, setProcessLoaded] = useState(false);

	useEffect(() => {
		setProcessValues(processTypes);
	}, []);

	function setProcessValues(processObj) {
		let processValue = {};
		processOptions = [];
		processOptions.push({ label: "", value: 0 });
		if (processObj && processObj.length > 0) {
			processObj.map((process, idx) => {
				processValue.label = process.processName;
				processValue.value = process.processTypeKey;
				processOptions.push(processValue);
				processValue = {};
			});
		}
		setProcessLoaded(true);
	}
	function processTypeHandler(selectedOption, action) {
		let selectedProcessTypeKey = selectedOption ? selectedOption.value : 0;
		let selectedProcessName = selectedOption ? selectedOption.label : "";
		setProcessTypeKey(selectedProcessTypeKey);
		setProcessSelected({ ...processSelected, label: selectedProcessName, value: selectedProcessTypeKey });
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let initialValues = {
			processTypeKey: processTypeKey,
		};

		if (!processTypeKey || processTypeKey === 0) {
			setError(t("error.deptProc.Reqd"));
			setIsSubmit(false);
		} else {
			handleSubmit(1, initialValues, submitComplete);
		}

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{processLoaded ? <Select
					name="processKey"
					options={processOptions}
					onChange={processTypeHandler}
					placeholder={""}
					value={processSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="processKey-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button></td>
		</tr>
	)

}
export default DepartmentProcessTableRow;